import Swiper from "swiper";

export const serviceSlider = () => {
  if (!document.querySelector(".js-service-slider")) {
    return;
  }

  let serviceSlider = null;
  const mediaQuery = window.matchMedia("(max-width: 1200px)");

  const handleMediaChange = (e) => {
    if (e.matches) {
      if (!serviceSlider) {
        serviceSlider = new Swiper(".js-service-slider", {
          slidesPerView: "auto",
          spaceBetween: 24,

          breakpoints: {
            768: {},
            1024: {},
          },
        });
      }
    } else {
      if (serviceSlider) {
        serviceSlider.destroy(true, true);
        serviceSlider = null;
      }
    }
  };

  // Initialize slider based on current media query state
  handleMediaChange(mediaQuery);

  // Listen for changes in the media query
  mediaQuery.addEventListener("change", handleMediaChange);
};
